/** Registry key for user-org membership refs (same collection SC uses). */
export const USER_ORGS = 'UserOrganization';
//# sourceMappingURL=userOrgs.js.map